<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Next Steps</h2>
				<p waBody="m" waColorText="quiet" waText>Every plugin is a Maven dependency away.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>You have a working JWebMP application. From here, add plugins for data grids, charts, calendars, or real-time messaging &mdash; each is a Maven dependency away. Some plugins &#40;like AG Grid, Chart.js, FullCalendar&#41; require Angular mode; others &#40;like WebAwesome, Font Awesome&#41; work in both modes. Check the plugin catalog for details.</p>
				<div class="wa-cluster wa-gap-s">
					<wa-button [routerLink]="['/plugins']" variant="brand">Browse Plugins</wa-button>
					<wa-button [routerLink]="['/architecture']" appearance="outlined" variant="neutral">See the Architecture</wa-button>
					<wa-button [routerLink]="['/real-time']" appearance="outlined" variant="neutral">Real-Time Messaging</wa-button>
				</div>
			</div>
		</div>
	</div>
</div>